<idl-seance-conflicts [seancesConflicts]="seancesConflicts" (messageClicked)="close($event)"></idl-seance-conflicts>